// The backend serves profile/avatar images from a fixed URL per user (it never changes across
// uploads) with a long-lived Cache-Control header, so browsers keep showing the old bytes after
// a new photo is uploaded. Appending a version query param that only changes when the *current*
// browser actually uploads/removes its own avatar forces a fresh fetch for that browser without
// re-fetching on every render.
const STORAGE_KEY = 'avatarCacheBust';

export function getAvatarCacheBust(): number {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? parseInt(stored, 10) || 0 : 0;
    } catch {
        return 0;
    }
}

export function bumpAvatarCacheBust(): number {
    const next = Date.now();
    try {
        localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
        // ignore storage errors (private browsing, quota, etc.)
    }
    return next;
}

export function withAvatarCacheBust(url?: string | null): string | undefined {
    if (!url) return url ?? undefined;
    const v = getAvatarCacheBust();
    if (!v) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${v}`;
}
